import styled from 'styled-components'

import { Select } from 'shared/ui/Select'

export const SelectPeriod = styled(Select)`
  width: 170px;
`
